export const softwareDevelopmentDesignSaudiArabia = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Boldare',
  url: 'https://boldare.com',
  description:
    'Digital product design and development company. We support clients with software development, digital transformation, AI services, UX/UI design, and MVP delivery.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Zwycięstwa 52',
    addressLocality: 'Gliwice',
    postalCode: '44-100',
    addressCountry: 'PL',
  },
  telephone: '+48 508 592 431',
  areaServed: 'Worldwide',
  memberOf: [
    {
      '@type': 'Organization',
      name: 'Takamol',
    },
    {
      '@type': 'Organization',
      name: 'Elm',
    },
    {
      '@type': 'Organization',
      name: 'Unifonic',
    },
    {
      '@type': 'Organization',
      name: 'Matic',
    },
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Services',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Software Development' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Digital Design' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Generative AI' },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Product Innovation & Strategy',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Quality & Project Management',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'DevOps & Infrastructure' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Consulting & Scaling' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Testing & Quality' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Dedicated Teams' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Team Augmentation' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Product Creation' },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'App Accessibility Audit & Implementation Services',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Digital Prototyping' },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Minimum Viable Product (MVP)',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'UX/UI Design' },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Product Design and Development',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Web and Mobile App Development',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'CTO as a Service' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Product Scaling' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Product-Market Fit' },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Full Cycle Product Development',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Code Audit and UX Audit' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'AI Services' },
      },
    ],
  },
};
